import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment";


export default function load_report_pdf(data) {
  const doc = new jsPDF();
  let dateTime = `${moment().format('MM/DD/YYYY HH:MM A')}`
  const userEmail = data[0]?.userEmail
  doc.page = 1;
  const pageWidth = doc.internal.pageSize.getWidth();
  data?.forEach((element, index) => {
    ganaratePdf(element);
    doc.addPage();
  });

  function ganaratePdf(element) {
    doc.setFont("Georgia");
    header(element);
  }
  function header(element) {
    doc.setFontSize(16);
    doc.text("Load Report", 5, 10);
    doc.text(`${element.title}`, 90, 10);
    doc.rect(85, 5, 41, 7);
    doc.setFontSize(8);

    //Branch 
    doc.setFont("Georgia", "bold");
    doc.text("Branch : ", 5, 20);
    // doc.setFont("Georgia", "normal");
    doc.text(`${element?.branch}`, 17, 20);

    //Truck
    doc.setFont("Georgia", "bold");
    doc.text("Truck : ", 80, 20);
    // doc.setFont("Georgia", "normal");
    doc.text('', 91, 20);

    //Total cases
    doc.setFont("Georgia", "bold");
    doc.text("Total Cases: ", 150, 15);
    // doc.setFont("Georgia", "normal");
    doc.text(`${element?.total_cases}`, 168, 15);


    //Load Date
    doc.setFont("Georgia", "bold");
    doc.text("Load Date : ", 150, 20);
    // doc.setFont("Georgia", "normal");
    doc.text(`${element?.load_date}`, 168, 20);

     //Route
     doc.setFont("Georgia", "bold");
     doc.text("Route : ", 5, 25);
    //  doc.setFont("Georgia", "normal");
     doc.text(`${element?.route}`, 17, 25);
 
     //Driver
     doc.setFont("Georgia", "bold");
     doc.text("Driver : ", 80, 25);
    //  doc.setFont("Georgia", "normal");
     doc.text(`${element?.driver}`, 91, 25);
 
     //Buffer Stock
     doc.setFont("Georgia", "bold");
     doc.text("Buffer Stock : ", 150, 25);
     doc.text('On: ', 168, 25);
    //  doc.setFont("Georgia", "normal");
     doc.text(`${element?.buffer_stock_online}%,`, 173, 25);
     doc.setFont("Georgia", "bold");
     doc.text('Off: ', 180, 25);
    //  doc.setFont("Georgia", "normal");
     doc.text(`${element?.buffer_stock_offline}%,`, 185, 25);
     doc.setFont("Georgia", "bold");
     doc.text('SKU: ', 192, 25);
    //  doc.setFont("Georgia", "normal");
     doc.text(`${element?.buffer_sku}`, 200, 25);


     //horizontal line
     doc.line(0, 27, pageWidth, 27)
     let startY = 35
     for (var key in element?.truck_load) {
      const val = element?.truck_load[key]
      tableBody(val, startY, key)
      startY = doc.lastAutoTable.finalY + 10
     }

  }

  function tableBody(data, startY, key) {
    if(startY > 265){
      doc.addPage();
      startY = 15
    }
    doc.setFont("Georgia", "bold");
    // doc.setFontSize(12);
    doc.text("Pack Size / Type : ", 5, startY);
    doc.setFont("Georgia", "bold");
    doc.text(key, 28, startY);
    autoTable(doc, {
        startY: startY + 5,
        margin: { right: 5, left: 5 },
            columnStyles: {
                0: { cellWidth: 30 },
                1: { cellWidth: 'auto' },
                2: {cellWidth: 20}

            },
          styles: {
            overflow: 'linebreak',
            fontSize: 6
        },
        bodyStyles: {
        textColor: '#000'
        },
        headStyles :{fillColor : [233, 35, 42]},
        columns: [
        { header: 'Material No.', dataKey: 'material_num' },
        { header: 'Material Name', dataKey: 'description' },
        { header: 'Cases', dataKey: 'quantity' },
            ],
        body: data,
    })
  }
  var pageCount = doc.internal.getNumberOfPages();

  for(var i = 1; i <= pageCount; i++) {
    // Go to page i
   doc.setPage(i);
    //Print Page 1 of 4 for example
    doc.line(0, 285, pageWidth, 285)
    doc.setFontSize(8);
    doc.text(`${dateTime}`, 4, 290);
    doc.text(`User: ${userEmail}`, 90, 290);
    doc.text(180,290, `Page ${String(i)} of  ${String(pageCount - 1)}`); 
}

  doc.deletePage(pageCount)
  doc.save(`${data[0]?.branch}_load_report_${data[0]?.load_date}.pdf`);
}
